<template>
  <div>
    <bar-top></bar-top>
    <div class="filter-bar">
      <div class="row">
        <h2 class="col-md-2">{{overviewTitle}}</h2>
        <div class=" col-md-2">
          <div class="paginationInfo" v-if="paginationData">
            {{ paginationData.from }}-{{ paginationData.to }} of {{ paginationData.total }}
          </div>
          <div class="" v-if="paginationData">
            <button
              class="btn btn-default btn-sm "
              :disabled="!paginationData || paginationData.current_page === 1"
              @click="table.gotoPreviousPage()"
            >
              <i class="fa fa-step-backward"i/>
            </button>
            <button
              class="btn btn-default btn-sm"
              :disabled="!paginationData || paginationData.current_page === paginationData.last_page"
              @click="table.gotoNextPage()"
            >
              <i class="fa fa-step-forward"i/>
            </button>
          </div>
        </div>
        <div class="form-inline col-md-3" >
            <!-- <label>Search for:</label> -->
            <!-- @keyup.enter.prevent="doQuickFilter" -->
            <input type="text" v-model="searchRec[tableCfg.quickFilterField]" class="form-control" @input="quickFilterChanged" @keyup.enter.prevent="doQuickFilter" :placeholder="tableCfg.quickFilterName">
            <button class="btn btn-default btn-sm" @click.prevent="resetFilter"><i class="fa fa-times"/></button>
            <b-form-checkbox v-if="tableCfg.advancedSearch" v-model="advancedFilter">Advanced</b-form-checkbox>
        </div>
        <div>
          <button v-if="!disableNew" class="btn btn-default btn-sm"
            @click="gotoNewDetail">
            <i class="fa fa-plus"></i>
          </button>
          <slot name="ExtraOptions">
          </slot>
        </div>
      </div>
      <b-card v-if="tableCfg.advancedSearch && advancedFilter" class="mb-2">
        <slot name="AdvancedFilter" v-if="advancedFilter">
          Here is the advanced filter
        </slot>
      </b-card>
    </div>
    <!-- <slot name="AboveTable">
    </slot> -->
    <b-progress v-if="batchMode" :value="batchCounter" :max="batchMax" :show-progress="true" :show-value="true"></b-progress>
    <alert-handler ref="alert"/>
    <vuetable
      ref="vuetable"
      :apiUrl="apiUrl"
      :fields="fields"
      :sortOrder="tableCfg.sortOrder"
      :perPage="50"
      :initialPage="findInitialPage()"
      :multiSort="true"
      :appendParams="appendParams"
      :css="css.table"
      v-on:vuetable:pagination-data="onPaginationData"
      v-on:vuetable:load-error="onLoadError"
    >
    <!-- v-on:vuetable:cell-clicked="onCellClicked" -->
      <template slot="actions" scope="props">
        <div class="custom-actions">
          <button class="btn btn-default btn-sm"
            :disabled="!privUser"
            @click="$router.push({ name: detailRouterUrl, params: {id: props.rowData.id}, query: {mode: 'edit'} })">
            <i class="fa fa-pencil"></i>
          </button>
          <slot name="ExtraRowActions" :rowData="props.rowData">
          </slot>
        </div>
      </template>
    </vuetable>
  </div>
</template>

<script>
import Vue from 'vue'
import Vuetable from 'vuetable-2/src/components/Vuetable'
// import Vuetable from '../../external/vuetable-2/src/components/Vuetable'
Vue.component('vuetable', Vuetable)
import PrivilegeMixin from './PrivilegeMixin'
import barTop from './BarTop.vue'
import alertHandler from '../components/AlertHandler.vue'
import CssConfig from './VuetableCssConfig.js'
import api from '../api'
import formatting from '../formatting'
import _ from 'lodash'

export default {
  components: {
    barTop,
    alertHandler,
    Vuetable
  },
  mixins: [PrivilegeMixin],
  props: {
    tableCfg: { type: Object, required: true }
  },
  // beforeCreate () { console.log('beforeCreate OverviewLayout') },
  // created () { console.log('created OverviewLayout') },
  // beforeUpdate () { console.log('beforeUpdate OverviewLayout') },
  // beforeMount () { console.log('beforeMount OverviewLayout') },
  // updated () { console.log('updated OverviewLayout') },
  // activated () { console.log('activated OverviewLayout') },
  // deactivated () { console.log('deactivated OverviewLayout') },
  // beforeDestroy () { console.log('beforeDestroy OverviewLayout') },
  // destroyed () { console.log('destroyed OverviewLayout') },
  data () {
    // console.log('data OverviewLayout')
    // Check stored filter and adjust searchRec
    let searchRec = this.$parent.searchRec
    let advancedFilter = true
    const storedFilterName = this.tableCfg.getFilterName(this)
    const defaultFilterRec = this.tableCfg.getDefaultFilter !== undefined ? this.tableCfg.getDefaultFilter(this) : {}
    const storedFilterRec = this.$store.getters.getFilterByName(storedFilterName)
    // console.log('OverviewLayout storedFilterRec', storedFilterRec)
    // console.log('OverviewLayout initial searchRec', searchRec)
    Object.keys(defaultFilterRec).forEach(function (key) {
      this.$set(searchRec, key, defaultFilterRec[key])
    }, this)
    if (storedFilterRec) {
      Object.keys(storedFilterRec).forEach(function (key) {
        if (storedFilterRec[key]) {
          if (storedFilterRec[key] !== defaultFilterRec[key]) advancedFilter = true
          this.$set(searchRec, key, storedFilterRec[key])
        }
      }, this)
    }
    // console.log('final searchRec', searchRec)
    let fixedParams = {}
    let appendParams = {}
    if (this.tableCfg.updateFilter) {
      this.tableCfg.updateFilter(this, fixedParams)
      Object.assign(appendParams, fixedParams)
    }
    Object.assign(appendParams, searchRec)
    // console.log('appendParams', appendParams)
    return {
      searchRec: searchRec,
      defaultFilterRec: defaultFilterRec,
      storedFilterName: storedFilterName,
      advancedFilter: advancedFilter,
      appendParams: appendParams,
      fixedParams: fixedParams,
      paginationData: null,
      apiUrl: api.getAPI_URL(this.tableCfg.overviewApiUrl),
      css: CssConfig,
      batchMode: false,
      batchCounter: 0,
      batchMax: 100
    }
  },
  // mounted () {
  //   // console.log('mounted OverviewLayout')
  // },
  computed: {
    overviewTitle () { return this.getTblCfg('overviewTitle') },
    fields () { return this.getTblCfg('fields') },
    detailRouterUrl () { return this.getTblCfg('detailRouterUrl') },
    disableNew () { return this.getTblCfg('disableNew') || !this.privUser },
    table () { return this.$refs.vuetable },
    alert () { return this.$refs.alert }
  },
  methods: {
    getTblCfg (key) {
      if (typeof this.tableCfg[key] === 'function') return this.tableCfg[key](this)
      else return this.tableCfg[key]
    },
    refreshTable () { Vue.nextTick(() => this.table.refresh()) },
    // onCellClicked (dataItem, field, event) {
    //   console.log('Click', dataItem, field)
    // },
    quickFilterChanged: _.debounce(function (e) {
      this.doQuickFilter()
    }, 500),
    doQuickFilter () {
      // console.log('doQuickFilter')
      let params = {}
      params[this.tableCfg.quickFilterField] = this.searchRec[this.tableCfg.quickFilterField]
      this.setFilter(params)
    },
    resetFilter () {
      // console.log('resetFilter', this.tableCfg.advancedSearch)
      this.setFilter({})
      if (this.tableCfg.advancedSearch) {
        // Object.keys(this.searchRec).forEach(function (key) { Vue.delete(this.searchRec, key) }, this)
        Object.keys(this.searchRec).forEach(function (key) { Vue.set(this.searchRec, key, null) }, this)
        Object.keys(this.defaultFilterRec).forEach(function (key) { Vue.set(this.searchRec, key, this.defaultFilterRec[key]) }, this)
      }
    },
    setFilter (params) {
      // console.log('setFilter', params, this.fixedParams, this.fixedParams.length)
      this.$store.commit({type: 'setFilter', name: this.storedFilterName, value: params})
      Object.keys(this.appendParams).forEach(function (key) { delete this.appendParams[key] }, this)
      Object.assign(this.appendParams, params)
      if (Object.keys(this.fixedParams).length) Object.assign(this.appendParams, this.fixedParams)
      this.refreshTable()
    },
    getFilterParams (advancedParams) {
      let result = {}
      Object.assign(result, advancedParams)
      if (Object.keys(this.fixedParams).length) Object.assign(result, this.fixedParams)
      return result
    },
    gotoNewDetail () {
      let route = { name: this.detailRouterUrl, params: {id: 'new'} }
      if (this.tableCfg.updateNewRoute) { this.tableCfg.updateNewRoute(this, route) }
      this.$router.push(route)
    },
    onPaginationData (data) {
      // console.log('onPaginationData', data)
      this.paginationData = data
      this.$store.commit({type: 'setActivePage', name: this.storedFilterName, value: data.current_page})
    },
    findInitialPage () {
      const activePage = this.$store.getters.getActivePageByName(this.storedFilterName)
      // console.log('findInitialPage', activePage)
      return activePage
    },
    onLoadError (response) {
      api.handleVueTableApiError(this.overviewTitle, response, this)
    },
    formatBoolean (value) { return formatting.formatBoolean(value) },
    formatDate (value) { return formatting.formatDate(value) },
    formatTimeStamp (value) { return formatting.formatTimeStamp(value) },
    formatMoney (value) { return formatting.formatMoney(value) },
    // Batch mode stuff
    getLabelForId (id, labelKey) {
      const tableData = this.table.tableData
      for (const i in tableData) {
        const rec = tableData[i]
        if (rec.id === id) {
          return rec[labelKey]
        }
      }
      return 'id=' + id
    },
    runNextBatch (index, processFnc, labelKey) {
      this.batchCounter = index + 1
      if (index + 1 < this.batchMax) {
        this.nextBatch(index + 1, processFnc, labelKey)
      } else {
        this.batchMode = false
        this.alert.appendMessage('Finished<br/>')
        this.table.selectedTo = [] // clear the selected list
        this.refreshTable()
      }
    },
    nextBatch (index, processFnc, labelKey) {
      const selectedIds = this.table.selectedTo
      // console.log('nextBatch enter', index)
      processFnc(selectedIds[index], data => {
        this.runNextBatch(index, processFnc, labelKey)
      }, error => {
        console.log('Error in batch callback', error)
        const id = selectedIds[index]
        const label = this.getLabelForId(id, labelKey)
        this.alert.appendMessage('Error for ' + label + '<br/>', true)
        this.runNextBatch(index, processFnc, labelKey)
      })
    },
    runBatch (processFnc, labelKey) {
      const selectedIds = this.table.selectedTo
      // this.$on('nextBatch', this.nextBatch)
      this.alert.reset()
      this.batchMode = true
      this.batchCounter = 0
      this.batchMax = selectedIds.length
      this.nextBatch(0, processFnc, labelKey)
    }

  }
}
</script>



// WEBPACK FOOTER //
// OverviewLayout.vue?0e93bb02